export default __webpack_public_path__ + "static/media/pptSlide11.f05cc049.png";